import { BaseForm } from '@forms/base.form';
import { Component, Input } from '@angular/core';
import { Employer } from '@models/recruiting/indeed/employer.model';
import { IndeedIndustry } from '@applicant-tracker/enums/indeed-industries.enum';
import { IndeedEmployeesCount } from '@applicant-tracker/enums/employees-count.enum';

@Component({
    selector: 'app-indeed-employer',
    templateUrl: './employer.template.html',
    styleUrls: ['./employer.style.scss'],
})
export class EmployerForm extends BaseForm {
    industries: { label: string; value: string }[] = [];
    employeesCount: { label: string; value: string }[];
    @Input() employer: Employer = new Employer();

    constructor() {
        super();
        this.generateOptions();
    }

    private generateOptions(): void {
        this.industries = Object.keys(IndeedIndustry).map((key) => ({ label: IndeedIndustry[key], value: key }));
        this.employeesCount = Object.keys(IndeedEmployeesCount).map((key) => ({
            label: IndeedEmployeesCount[key],
            value: key,
        }));
    }
}
